<template>
  <div class="faq-collapse">
    <b-btn
      variant="link"
      size="lg"
      :class="{expanded: expanded}"
      @click="toggle"
      v-html="faq.question"
    ></b-btn>
    <b-collapse :id="collapseId" :aria-expanded="expanded">
      <b-card v-html="faq.answer"></b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "faq-collapse",
  props: ["faq"],
  data: () => {
    return {
      expanded: false
    };
  },
  computed: {
    collapseId: function() {
      return "categ-" + this._uid;
    }
  },
  methods: {
    toggle: function() {
      this.expanded = !this.expanded;
      this.$root.$emit("bv::toggle::collapse", this.collapseId);
    }
  }
};
</script>

<style lang="scss">
@import "~assets/scss/globals.scss";

.faq-collapse {
  color: #343434;
  .btn.btn-link.btn-lg {
    color: #343434;
    font-size: 1.3em;
    word-wrap: normal;
    white-space: normal;
    text-align: left;
    position: relative;
    font-weight: 500;
    &::before {
      content: "+";
      color: #007bff;
      text-decoration: none;
      width: 1em;
      display: block;
      position: absolute;
      left: 0;
    }
    &.expanded::before {
      content: "-";
    }

    &:focus {
      box-shadow: none;
      text-decoration-line: none;
    }
    &:hover {
      text-decoration-line: underline;
    }
  }

  .card {
    border: none;
    padding-left: 1.5rem;
    .card-block {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// FaqCollapse.vue?d4698c02